import React, { useState, useEffect } from 'react';
import LoginUnificado from './componentes/LoginUnificado';
import VistaDocenteTabs from './componentes/VistaDocenteTabs';
import VistaAdminLayout from './componentes/VistaAdminLayout';

function App() {
  const [logueado, setLogueado] = useState(false);
  const [rol, setRol] = useState('');
  const [vistaActiva, setVistaActiva] = useState('gestion-admins');

  useEffect(() => {
    if (localStorage.getItem('adminLogueado') === 'true') {
      setLogueado(true);
      setRol('admin');
    } else if (localStorage.getItem('profesorId')) {
      setLogueado(true);
      setRol('profesor');
    }
  }, []);

  const iniciarSesionAdmin = () => {
    setRol('admin');
    setLogueado(true);
  };

  const iniciarSesionProfesor = () => {
    setRol('profesor');
    setLogueado(true);
  };

  const cerrarSesion = () => {
    localStorage.clear();
    setLogueado(false);
    setRol('');
  };

  const rolAdmin = localStorage.getItem('rolAdmin'); // "admin" o "tecnico"

  // ✅ Si el técnico intenta entrar a la vista de permisos, lo devolvemos a Pedidos
  useEffect(() => {
    if (logueado && rol === 'admin' && rolAdmin === 'tecnico' && vistaActiva === 'permisos-tecnicos') {
      setVistaActiva('lista-pedidos');
    }
  }, [logueado, rol, rolAdmin, vistaActiva]);

  return (
    <div className="App">
      {!logueado ? (
        <LoginUnificado
          onLoginAdmin={iniciarSesionAdmin}
          onLoginProfesor={iniciarSesionProfesor}
        />
      ) : rol === 'admin' ? (
        <VistaAdminLayout
          modo={rolAdmin === 'admin' ? 'admin' : 'tecnico'}
          vistaActiva={vistaActiva}
          setVistaActiva={setVistaActiva}
          cerrarSesion={cerrarSesion}
        />
      ) : rol === 'profesor' ? (
        <VistaDocenteTabs onCerrarSesion={cerrarSesion} />
      ) : null}
    </div>
  );
}

export default App;
